import React from 'react';
import moment from "moment";

const TaskDetailsTable = ({ title, tasks, colClass = 'col-4' }) => {
    return (
        <div className={`${colClass} mt-5 ${colClass === 'col-4' && colClass.includes('ps-0') ? 'ps-0' : colClass === 'col-4' && colClass.includes('pe-0') ? 'pe-0' : ''}`}>
            <p className={'outer-title mt-4'}>{title}</p>
            <div className={'box-card'}>
                <div className={'p-3 mt-4'}>
                    <table className="table text-white">
                        <thead>
                        <tr>
                            <th scope="col">Nombre de popups</th>
                            <th scope="col">Date</th>
                        </tr>
                        </thead>
                        <tbody>
                        {tasks.details !== [] && (tasks.details).map((d, index) =>
                            <tr key={index} className={'text-white'}>
                                <td>{d.nbPopups}</td>
                                <td>{moment(d.date).format('L')}</td>
                            </tr>
                        )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default TaskDetailsTable;